import { Proposal, LoanSimulation } from '@src/shared/models';

export function formatBR(value: number) {
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  }).format(value);
}

export function formatBRDate(value: string | undefined | null) {
  if (!value) {
    return '';
  }

  const [year, month, day] = value.split('-');

  return `${day.slice(0, 2)}/${month}/${year}`;
}

export function getDownPaymentPlusInstallment(loanSimulation: LoanSimulation) {
  const testSchedule = loanSimulation?.schedule?.length > 0;
  const firstSchedulePayment = testSchedule
    ? loanSimulation?.schedule[0]?.payment
    : null;

  return `${formatBR(loanSimulation?.downPayment)} + ${loanSimulation?.schedule?.length}x ${formatBR(firstSchedulePayment)}`;
}

type formatFlightProps = {
  loading: boolean;
  proposal: Proposal;
};

export function formatMapFlights({ loading, proposal }: formatFlightProps) {
  return loading
    ? [
        {
          title: '',
          from: '',
          to: '',
          isReturn: false,
          only: false,
        },
        {
          title: '',
          from: '',
          to: '',
          isReturn: true,
          only: false,
        },
      ]
    : [
        ...proposal?.flightData.map((flight) =>
          flight.startFlight
            ? {
                title: formatBRDate(flight.startFlight.date),
                from: flight.startFlight.from,
                to: flight.startFlight.to,
                only: proposal?.flightData.length === 1,
                isReturn: false,
              }
            : null
        ),
        ...proposal?.flightData.map((flight) =>
          flight.endFlight
            ? {
                title: formatBRDate(flight.endFlight.date),
                from: flight.endFlight.from,
                to: flight.endFlight.to,
                only: proposal?.flightData.length === 1,
                isReturn: true,
              }
            : null
        ),
      ].filter((flight) => flight);
}

export function removeHttpPrefix(url: string): string {
  if (typeof url !== 'string') return url;

  return url.replace(/^(https?:\/\/)?(www\.)?/i, '');
}
